import { MemoTriggerTypesTab } from '../ValidationsPage/components/modules/TriggerTypes';
import { SettingsShell } from './components/SettingsShell';
import { SettingsContentHeader } from './components/SettingsContentHeader';

export const MaintenanceSettingsPage = () => {
  return (
    <SettingsShell activeTabPath="maintenance" breadcrumbLabel="Maintenance Settings">
      <SettingsContentHeader
        title="Maintenance Settings"
        subtitle="Manage maintenance trigger types."
      />

      <MemoTriggerTypesTab />
    </SettingsShell>
  );
};
